<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] current="{{filterValue}}"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <div class="tab_section custom_list">
        <fury-list name={{filterValue}} [hideSearchInput]="true" [columns]="columns">
          <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabChangeHandle($event)">
            <mat-tab label="New">
              <fury-contact-table [searchForm]="searchForm" [itemList]="itemList"
                [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
                (search)="search($event)" (fetchContact)="fetchContact($event)"></fury-contact-table>
              <mat-paginator class="pegig" [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize"
                [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons
                [selectConfig]="selectConfig" [ngClass]="{'mat-pegig': pageSize === 9999}"
                aria-label="Select page of periodic elements">
              </mat-paginator>
  
            </mat-tab>
            <mat-tab label="In Progress">
              <fury-contact-table [searchForm]="searchForm" [itemList]="itemList"
                [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
                (search)="search($event)" (fetchContact)="fetchContact($event)"></fury-contact-table>
              <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount"
                [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig]="selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}" aria-label="Select page of periodic elements">
              </mat-paginator>
            </mat-tab>
            <mat-tab label="Completed">
              <fury-contact-table [searchForm]="searchForm" [itemList]="itemList"
                [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
                (search)="search($event)" (fetchContact)="fetchContact($event)"></fury-contact-table>
              <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount"
                [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig]="selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}" aria-label="Select page of periodic elements">
              </mat-paginator>
            </mat-tab>
          </mat-tab-group>
        </fury-list>
      </div>
  
  
    </fury-page-layout-content>
  </fury-page-layout>